import { commonConfigurations } from './environment.commonConfigurations';
import { EnvironmentSpecificServiceList, IEnvironment, IEnvironmentSpecificConfigurations } from './environment.model';

const initialNavigation: any = 'disabled';

const environmentSpecificServiceList = new EnvironmentSpecificServiceList('dev');

export const environmentSpecificConfigurations: IEnvironmentSpecificConfigurations = {
    IsAzStorage: true,
    BuildVersion: 'v1.526.0',
    production: true,
    IsStaging: false,
    beeUid: 'dev',
    isSSo: false,
    isDevLocal: false,
    initialNavigation,
    action: `http://`,
    SubDomainName: `pcx.seliselocal.com`,
    DomainName: `seliselocal.com`,
    SessionKey: `set_from_acp.seliselocal.com`,
    landingUri: `http://pcx.seliselocal.com`,
    SiteId: 'CF55B6DF-585D-4AEF-8A71-43C11E8ACEA8',
    BuildPipelineId: 'baad454e-7566-43e7-a124-1aa290e770ad',
    MaintenanceManagerURL: `https://maintenancemanager.seliselocal.com/api/tenants`,
    JarowaWorkorderUrl: `https://www-appenzell-pool.enable.jarowa.ch/workOrderDetail/WORKORDER_ID/00000000-0000-0000-0000-000000000000`,
    WagePredictionService: `https://ipex-wage-prediction.stage.ipex.ch`,
    WagePredictionServiceUserName: `selise`,
    WagePredictionServicePassword: `ibexDerSteinbock#008`,
    caseCenterUri: 'http://upload-ipex.seliselocal.com',
    SlackWebHookUrl: 'https://hooks.slack.com/services/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',
    SlackAdminWebHookUrl: 'https://hooks.slack.com/services/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',
    ClaimCenterUri: "https://selise-repair-center.stage.ipex.ch",
    IpexFileService: 'https://ipex-file-service-jx-d.tech.ipex.ch',
    IpexDataBeastService: 'https://ipex-data-beast-jx-d.tech.ipex.ch',
    ClaimCenterLinkBaseUri: "https://selise-repair-center-jx-d.tech.ipex.ch",
    UILMUrl: 'https://api.seliseblocks.com/uilm/v1/Key/GetUilmFile',
    ProjectKey: '368F2327A9444A1798104730268C51DC',
    AutoClearingUserId: '8fb2b75b-38cb-4c50-869e-ca76a2e4a8b0'
};

export const environment: IEnvironment = {
    ...commonConfigurations,
    ...environmentSpecificConfigurations,
    ...environmentSpecificServiceList
};

export const environmentDev = environment;


/*const initialNavigation: any = 'disabled';
export const environment: IEnvironment = {
    BuildVersion: 'v2021.11.19.2',
    production: true,
    IsStaging: false,
    beeUid: 'dev',
    isSSo: false,
    initialNavigation,
    /!**
     * micro-sercice
     *!/
     Identity: `${microservices.devBaseUrl}/${microservices.tenant.urlPrefix}/${microservices.tenant.dev}/TenantManager/TenantManagerQuery/GetIdentity`,
     Sites: `${microservices.devBaseUrl}/${microservices.tenant.urlPrefix}/${microservices.tenant.dev}/TenantManager/SiteManagerQuery/GetSites`,
     Apps: `${microservices.devBaseUrl}/${microservices.appCatalogue.urlPrefix}/${microservices.appCatalogue.dev}/AppCatalogue/AppManagerQuery/GetApps`,
     Security: `${microservices.devBaseUrl}/${microservices.uam.urlPrefix}/${microservices.uam.dev}/UserAccessManagement/`,
     Token: `${microservices.devBaseUrl}/${microservices.identity.urlPrefix}/${microservices.identity.dev}/identity/token`,
     SecurityIdentity: `${microservices.devBaseUrl}/${microservices.identity.urlPrefix}/${microservices.identity.dev}/identity/`,
     Captcha: `${microservices.devBaseUrl}/captcha/captcha/CaptchaCommand/`,
     DataCore: `${microservices.devBaseUrl}/pds/AppSuiteDataCore/`,
     Storage: `${microservices.devBaseUrl}/${microservices.storageService.urlPrefix}/${microservices.storageService.dev}/StorageService/`,
     EmailService: `${microservices.devBaseUrl}/${microservices.mailService.urlPrefix}/${microservices.mailService.dev}/MailService`,
     NotificationService: `${microservices.devBaseUrl}/${microservices.notification.urlPrefix}/${microservices.notification.dev}`,
     AggregateService: `${microservices.devBaseUrl}/${microservices.aggregator.urlPrefix}/${microservices.aggregator.dev}/Service-Aggregator/ServiceAggrigation/`,
     PdfGeneratorV2: `${microservices.devBaseUrl}/${microservices.pdfGenerator2.urlPrefix}/${microservices.pdfGenerator2.dev}/PdfGeneratorHost/`,
     TemplateEngineService: `${microservices.devBaseUrl}/${microservices.templateEngine.urlPrefix}/${microservices.templateEngine.dev}/TemplateEngineService/`,
     GQLQueryUri: `${microservices.devBaseUrl}/${microservices.gqlQuery.urlPrefix}/${microservices.gqlQuery.dev}/graphql`,
     GQLMutationUri: `${microservices.devBaseUrl}/${microservices.gqlCommand.urlPrefix}/${microservices.gqlCommand.dev}/graphql`,
     EmailSyncService: `${microservices.devBaseUrl}/business-emailsync/EmailSyncService/`,
     PCXBusiness: `${microservices.devBaseUrl}/business-pcx/PCXWebService/`,
     StaticResourceCDN: `https://stg-ecap.s3.eu-central-1.amazonaws.com/`,


    /!**
     * Business-sercice
     *!/
    /!**
     * Other config
     *!/

    CdnBaseUrl: `https://az-cdn.selise.biz/selisecdn/cdn/`,
    CdnTenantBaseUrl: `https://az-cdn.selise.biz/selisecdn/cdn/pcx/`,
    SiteLogo: `https://az-cdn.selise.biz/selisecdn/cdn/pcx/images/ipex_logo.svg`,
    topBgImageUrl: `https://az-cdn.selise.biz/selisecdn/cdn/pcx/`,
    action: `http://`,
    SubDomainName: `acp.seliselocal.com`,
    DomainName: `seliselocal.com`,
    SessionKey: `set_from_acp.seliselocal.com`,
    Client_ID: `0069BD6A-44DB-4C31-B69F-A397B7EA760B`,
    NotificationHubName: `NotifierServerHub`,
    PersonFields: [
        `ItemId`,
        `CreatedBy`,
        `Tags`,
        `DateOfBirth`,
        `Sex`,
        `FirstName`,
        `LastName`,
        `ProfileImage`,
        `Email`,
        `DisplayName`,
        `ProfileImageId`,
        `IsVerified`,
        `Salutation`,
        `Nationality`,
        `PhoneNumber`,
        `Organization`,
        `OrganizationId`,
        `LastLogInTime`,
        `LogInCount`,
        `ColorCode`,
        `ProposedUserId`
    ],
    toBgImages: [`backgrounds/top-bground.jpg`],
    currentDateFormat: `dd MMM yyyy`,
    defaultLangKey: `en`,
    currency: `EUR`,
    landingUri: `http://pcx.seliselocal.com`,
    language: [
        {
            id: `en`,
            title: `ENGLISH`,
            flag: `us`,
            value: `en-US`
        },
        {
            id: `de`,
            title: `GERMAN`,
            flag: `de`,
            value: `de-DE`
        }
    ],
    isFloatingChatPanelEnable: true,
    SiteId: 'CF55B6DF-585D-4AEF-8A71-43C11E8ACEA8',
    DefaultPackagePath: './assets/i18n/generic-app/',
    BuildPipelineId: 'baad454e-7566-43e7-a124-1aa290e770ad',
    IsAzStorage: true
};*/
